import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { PerfilRequest } from '../../requests/usuario/perfil.request';
import { ListaPerfilResponse } from '../../responses/usuario/lista-perfil.response';
import { PerfilResponse } from '../../responses/usuario/perfil.response';
import { PerfilRestricaoResponse } from '../../responses/usuario/perfil-restricao.response';
import { ListaUsuarioPerfilResponse } from '../../responses/usuario/lista-usuario-perfil.response';

@Injectable({
  providedIn: 'root',
})
export class PerfilService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(pesquisa: string, paginaAtual: number): Observable<ListaPerfilResponse> {
    const uri: string = `Perfil?pesquisa=${pesquisa}&paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaPerfilResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getAll(): Observable<ListaPerfilResponse> {
    const uri: string = `Perfil`;

    return this.httpClient
      .get<ListaPerfilResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  // Lookup completo de perfis (id + nome), sem o gate de permissão do Perfil paginado.
  // Usado para popular seletores de perfil (ex.: configuração do Kanban de Compras).
  public getAllLookup(): Observable<ListaPerfilResponse> {
    const uri: string = `Perfil/getAll`;

    return this.httpClient
      .get<ListaPerfilResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Vínculos perfil -> usuário da empresa logada (só ids). Usado para expandir
   *  destinatários por perfil das automações antes de disparar a ação. */
  public getUsuariosPorPerfil(idsPerfil: number[]): Observable<ListaUsuarioPerfilResponse> {
    let params = new HttpParams();
    idsPerfil.forEach(id => { params = params.append('idsPerfil', id); });

    return this.httpClient
      .get<ListaUsuarioPerfilResponse>(environment.urlApiUsuario + 'Perfil/usuarios', {
        ...this.addHeaderToken(),
        params,
      })
      .pipe(catchError(this.handleError));
  }

  public excluir(idPerfil: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(environment.urlApiUsuario + `Perfil/idPerfil/${idPerfil}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public Incluir(perfilRequest: PerfilRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(environment.urlApiUsuario + `Perfil`, perfilRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public Alterar(idPerfil: number, perfilRequest: PerfilRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiUsuario + `Perfil/idPerfil/${idPerfil}`,
        perfilRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public ObterPorId(idPerfil: number): Observable<PerfilResponse> {
    return this.httpClient
      .get<PerfilResponse>(environment.urlApiUsuario + `Perfil/idPerfil/${idPerfil}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public ObterRestricoesPorIds(idsPerfil: number[]): Observable<PerfilRestricaoResponse> {
    let params = new HttpParams();
    idsPerfil.forEach(idPerfil => {
      params = params.append('idsPerfil', idPerfil);
    });

    return this.httpClient
      .get<PerfilRestricaoResponse>(environment.urlApiUsuario + `Perfil/Restricoes`, {
        ...this.addHeaderToken(),
        params,
      })
      .pipe(catchError(this.handleError));
  }
}
